import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { TextTransformType, XpressDeliveryOrderDetail } from '@shared/models';
import { SharedDeliveryOrderService } from '@shared/services/shared-delivery-order.service';
import { Utils } from 'app/utils/utils';
import { MessageService } from 'primeng/api';

@Component({
	selector: 'booking-people-tab',
	templateUrl: './booking-people-tab.component.html',
	styleUrl: './booking-people-tab.component.scss'
})
export class BookingPeopleTabComponent implements OnInit {
	@Input() deliveryOrderDetails!: XpressDeliveryOrderDetail;

	isCustomerStatisticsLoading: boolean = false;
	TextTransformType = TextTransformType;

	constructor(
		private deliveryOrderService: SharedDeliveryOrderService,
		private messageService: MessageService,
		private cdr: ChangeDetectorRef
	) {
	}

	ngOnInit(): void {
		void this.loadCustomerStatistics();
	}

	get riderFullName(): string {
		if (!this.deliveryOrderDetails.RiderFirstName &&
			!this.deliveryOrderDetails.RiderLastName) {
			return '';
		}

		return `${this.deliveryOrderDetails.RiderFirstName} ${this.deliveryOrderDetails.RiderLastName}`;
	}

	get userRatingFormatted() {
		return this.deliveryOrderDetails.UserRating.toFixed(1);
	}

	get isDefaultGuestBackedCustomer(): boolean {
		return Utils.isGuestNameBackedUser(this.deliveryOrderDetails.UserId);
	}

	get guestBackedCustomerSource(): string {
		return Utils.getGuestNameBackedUserSource(this.deliveryOrderDetails.UserId);
	}

	get customerDisplayName(): string {
		if (this.isDefaultGuestBackedCustomer) {
			return this.deliveryOrderDetails.FullUserName || this.deliveryOrderDetails.UserName || 'N/A';
		}

		const fullName = `${this.deliveryOrderDetails.UserFirstName || ''} ${this.deliveryOrderDetails.UserLastName || ''}`.trim();
		return fullName || this.deliveryOrderDetails.FullUserName || this.deliveryOrderDetails.UserName || 'N/A';
	}

	get customerDisplayPhone(): string {
		return this.isDefaultGuestBackedCustomer
			? this.deliveryOrderDetails.UserPhone || 'N/A'
			: this.deliveryOrderDetails.UserPhoneMask || this.deliveryOrderDetails.UserPhone || 'N/A';
	}

	get customerImageUrl(): string {
		return this.isDefaultGuestBackedCustomer ? '' : this.deliveryOrderDetails.UserImageUrl;
	}

	handleDriverDetailClick(): void {
		// Handle driver detail click
	}

	private async loadCustomerStatistics(): Promise<void> {
		if (!this.deliveryOrderDetails?.UserId || this.isDefaultGuestBackedCustomer) {
			return;
		}

		this.isCustomerStatisticsLoading = true;
		this.cdr.markForCheck();

		try {
			const data = await this.deliveryOrderService.getCustomerStatistics(
				{ UserId: this.deliveryOrderDetails.UserId },
				this.messageService
			);

			if (!data) {
				return;
			}

			if (!data.Success) {
				this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
				return;
			}

			this.deliveryOrderDetails.BookingsCount = data.BookingsCount;
			this.deliveryOrderDetails.CompletedCount = data.CompletedCount;
			this.deliveryOrderDetails.CompletedPercent = data.CompletedPercent;
			this.deliveryOrderDetails.TotalSpend = data.TotalSpend;
		} finally {
			this.isCustomerStatisticsLoading = false;
			this.cdr.markForCheck();
		}
	}
}
